// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"518":"e06aaa1d","916":"1faa39ba"}[chunkId] + ".css";
};